import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfigService } from 'src/app/services/config.service';
import { AuthService } from 'src/app/services/auth.service';
import { Util } from 'src/app/util';
import { ActionType } from 'src/app/models/action';
import { LoginDialogComponent } from '../../login/components/login-dialog/login-dialog.component';
import { ApiService } from 'src/app/services/api.service';
import { ResetPasswordDialogComponent } from 'src/app/_shared/components/dialogs/reset-password-dialog/reset-password-dialog.component';

@Component({
  selector: 'app-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.scss'],
})
export class BlankComponent implements OnInit {
  private readonly apiService = inject(ApiService);

  @ViewChild('resetPasswordDialog', { static: true }) resetPasswordDialog!: ResetPasswordDialogComponent;

  readonly showConfirmationEmailDialog = signal<boolean>(false);
  readonly confirmationEmailResult = signal<boolean>(false);
  readonly confirmationEmailLabel = signal<string>('');

  private internalLogin: boolean;
  private guestModeEnabled: boolean;

  afterLogin: string;
  customLoginUrl: string;

  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.guestModeEnabled = this.configService.get().inviteGuestAccountActive && this.configService.get().customLoginUrl !== null;
    this.customLoginUrl = this.configService.get().customLoginUrl;
    this.internalLogin = this.route.snapshot.queryParams.internalLogin ?? false;
    this.afterLogin = this.route.snapshot.queryParams.afterLogin ?? '/';

    const chpwd = this.route.snapshot.queryParams.chpwd;
    const v = this.route.snapshot.queryParams.v;

    // Needed for handle the case of login after reload page
    if (this.authService.isAuthenticated()) {
      return this.router.navigateByUrl(this.afterLogin);
    }

    if (chpwd) {
      this.resetPasswordDialog.openModal(chpwd);
    } else if (v) {
      this.apiService.confirmUser(v).subscribe({
        next: () => {
          this.confirmationEmailResult.set(true);
          this.showConfirmationEmailDialog.set(true);
          this.confirmationEmailLabel.set('login.confirm.validated');
        },
        error: () => {
          this.confirmationEmailResult.set(false);
          this.showConfirmationEmailDialog.set(true);
          this.confirmationEmailLabel.set('login.confirm.notValidated');
        }
      });
    } else {
      setTimeout(() => {
        this.openLoginForm();
      });
    }
  }

  private openLoginForm() {
    if (this.customLoginUrl) {
      if (this.afterLogin) {
        sessionStorage.setItem('afterLogin', this.afterLogin);
      }

      if (!this.guestModeEnabled && !this.internalLogin) {
        // Esto es una chapucilla para que cuando tienes modo privado y ezproxy no se quede en bucle la página. By mmacanas
        if (this.configService.get().ssoType === 'EZPROXY') {
          sessionStorage.setItem('isLoggingIn', 'true');
        }
        this.authService.getExternalLoginUrl(this.customLoginUrl).subscribe((url) => (window.location.href = url));

        return;
      }
    }

    this.dialog
      .open(LoginDialogComponent, {
        disableClose: true,
        backdropClass: 'blur-backdrop',
        closeOnNavigation: false,
        data: {
          screen: this.guestModeEnabled ? 'guest' : 'login',
          hideClose: true,
        },
      })
      .afterClosed()
      .subscribe((value) => {
        if (value) {
          window.location.reload();
        } else {
          const action = Util.getAction();
          if (action) {
            Util.setAction({
              ...action,
              type: ActionType.NONE,
            });
          } else {
            Util.removeAction();
          }
        }
      });
  }

  closeConfirmationEmailDialog() {
    this.showConfirmationEmailDialog.set(false);
    if (this.confirmationEmailResult()) {
      this.openLoginForm();
    }
  }

  handleResetPasswordDialog() {
    this.openLoginForm();
  }
}
